import { topbarTokens } from '../Topbar/tokens';

export const aiAdminTokens = {
    ...topbarTokens,
    color: {
        ...topbarTokens.color,
        // Verde para lo que está listo para usarse (credenciales, saldo), ámbar
        // para lo que se puede elegir pero va a fallar, rojo para lo inservible.
        ok: '#0F7B4F',
        okSoft: '#E8F5EF',
        warn: '#9A6400',
        warnSoft: '#FDF3E0',
        chipBg: '#F3F4F6',
    },
};
